import { PreviewModes } from '../../../constants';

export type GetPreviewModeFromPathReturnType = {
  previewMode: PreviewModes | null;
  previewTenantDomain: string | null;
};

const previewModes = Object.values(PreviewModes);

export default function getPreviewModeFromPath(
  path?: string,
): GetPreviewModeFromPathReturnType {
  const segments = path?.split('/').filter(Boolean) || [];
  const previewMode = segments[0] as PreviewModes;
  const previewTenantDomain = segments[1] || '';

  if (
    segments.length > 1 &&
    previewModes.includes(previewMode) &&
    previewTenantDomain.includes('.')
  ) {
    return {
      previewMode,
      previewTenantDomain,
    };
  }

  return {
    previewMode: null,
    previewTenantDomain: null,
  };
}
